// John Eldhose 20190104
import React, { Component } from 'react';
import { connect } from 'react-redux';
import  { Link } from 'react-router-dom';
import { Button, Checkbox, Grid, InputAdornment, MenuItem, Paper, Snackbar, TextField, Typography } from '@material-ui/core';
import { Create } from '@material-ui/icons';
import { getProfile } from '../../Api/getProfile';
import { getAddress } from '../../Api/getAddress';
import { getLMDProds } from '../../Api/getLMDProds';
import { addLMDRMA } from '../../Api/addLMDRMA';
import { Americas, APAC, Currency, Price, Product, ServiceCenter, ServiceCenterAddress, Warranty } from '../lib/LMD';
import LMDCache from '../../actions/LMDCache';

const CACHE = {
  BillingEMail: '',
  ShippingAddressID: '',
  ShippingAddress: '',
  ShippingCity: '',
  ShippingState: '',
  ShippingZip: '',
  ShippingCountry: '',
  BillingAddressID: '',
  BillingAddress: '',
  BillingCity: '',
  BillingState: '',
  BillingZip: '',
  BillingCountry: '',
  Product: '',
  SerialNumber: '',
  Warranty: '',
  ServiceCenter: '',
  Currency: '',
  FreightInsurance: '',
  PurchaseYear: '',
  FaultDescription: ''
};

class App extends Component {

  state = {
    ContactName: '',
    ContactEMail: '',
    CompanyName: '',
    BillingEMail: '',
    ShippingAddressID: '',
    ShippingAddress: '',
    ShippingCity: '',
    ShippingState: '',
    ShippingZip: '',
    ShippingCountry: '',
    BillingAddressID: '',
    BillingAddress: '',
    BillingCity: '',
    BillingState: '',
    BillingZip: '',
    BillingCountry: '',
    Product: '',
    SerialNumber: '',
    RMADescription: '',
    Warranty: '',
    ServiceCenter: '',
    Currency: 'USD',
    FreightInsurance: '',
    FaultDescription: '',
    PurchaseYear: '',
    Addresses: [],
    Products: [],
    Terms: false,
    Warning: false,
    warningMessage: '',
    Message: ''
  }
  componentWillMount() {
    this.setState(this.props.LMDCache);
    getProfile()
      .then((prof) => {
        if(prof['status'] === 'true')
          this.setState({
            ContactName: prof.data['FirstName'] + ' ' + prof.data['LastName'],
            ContactEMail: prof.data['email'],
            CompanyName: prof.data['CompanyDescription'],
            RMADescription: 'RMA: ' + prof.data['CompanyDescription']
          });
      })
      .catch((error) => {
        console.log(error);
      })
    getAddress()
      .then((add) => {
        if(add['status'] === 'true')
          this.setState({ Addresses: add['data'] });
      })
      .catch((error) => {
        console.log(error);
      })
    getLMDProds()
      .then((prods) => {
        if(prods['status'] === 'true')
          this.setState({ Products: prods['data'] });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  componentWillUnmount() {
    this.props.setLMDCache(CACHE);
  }
  updateCache = () => {
    const keys = Object.keys(CACHE);
    for(var i = 0; i < keys.length; i++)
      CACHE[keys[i]] = this.state[keys[i]];
  }
  currencyItmes = () => {
    const keys = Object.keys(Currency);
    var ci = [];
    for(var i = 0; i < keys.length; i++)
      ci.push(<MenuItem key={keys[i]} value={keys[i]}>{keys[i]}</MenuItem>);
    return ci;
  }
  handleUserInput = (event) => {
    this.setState ({ [event.target.name]: event.target.value });
    if(
      event.target.name === 'Product' || event.target.name === 'Currency' ||
      event.target.name === 'PurchaseYear'
    ) {
      const prod = (event.target.name === 'Product') ? event.target.value :
        this.state.Product;
      const curr = (event.target.name === 'Currency') ? event.target.value :
        this.state.Currency;
      const year = (event.target.name === 'PurchaseYear') ? event.target.value :
        this.state.PurchaseYear;
      const d = new Date();
      if(!(
        prod === '' || curr === '' || year === '' || year < 2000 ||
        (d.getFullYear() - year) < 0 ||
        typeof Price[prod] === 'undefined' ||
        typeof Price[prod][curr] === 'undefined' || Price[prod][curr].length < 1
      )) {
        const age = ((d.getFullYear() - year) < Price[prod][curr].length) ? (d.getFullYear() - year) : (Price[prod][curr].length - 1);
          this.setState({ FreightInsurance: Price[prod][curr][age] });
      }
      else
        this.setState({ FreightInsurance: '' });
    }
    else if(event.target.name === 'ServiceCenter')
      this.setState({ Message: ServiceCenterAddress[event.target.value] });
  }
  handleAddressChange = (event) => {
    var type = (event.target.name === 'Billing') ? 'Billing' : 'Shipping';
    for(var i = 0; i < this.state.Addresses.length; i++)
      if(event.target.value === this.state.Addresses[i].ADDRESSID)
        break;
    if(i < this.state.Addresses.length) {
      this.setState({
        [type + 'AddressID']: this.state.Addresses[i].ADDRESSID,
        [type + 'Address']: this.state.Addresses[i].ADDRESS1,
        [type + 'City']: this.state.Addresses[i].CITY,
        [type + 'State']: this.state.Addresses[i].STATE,
        [type + 'Zip']: this.state.Addresses[i].POSTALCODE,
        [type + 'Country']: this.state.Addresses[i].COUNTRY
      });
    }
    if(type === 'Shipping' && this.state.Addresses[i].COUNTRY !== '') {
      if(Americas.findIndex(
      (c) => (c.toLowerCase() === this.state.Addresses[i].COUNTRY.toLowerCase())
      ) >= 0)
        this.setState({
          ServiceCenter: 'Canada', Message: ServiceCenterAddress['Canada']
        });
      else if(APAC.findIndex(
      (c) => (c.toLowerCase() === this.state.Addresses[i].COUNTRY.toLowerCase())
      ) >= 0)
        this.setState({ ServiceCenter: 'Australia', Message: ServiceCenterAddress['Australia'] });
      else
        this.setState({ ServiceCenter: 'York, UK', Message: ServiceCenterAddress['York, UK'] });
    }
  }
  handleProductChange = (event) => {
    var i;
    for(i = 0; i < this.state.Products.length; i++)
      if(event.target.value === this.state.Products[i].Serial)
        break;
    if(i < this.state.Products.length) {
      this.setState({
        Product: this.state.Products[i].Product,
        SerialNumber: this.state.Products[i].Serial
      });
      this.handleUserInput({ target: {
        name: 'Product', value: this.state.Products[i].Product
      }});
    }
  }
  handleFaultChange = (event) => {
    this.setState({ FaultDescription: event.target.value });
  }
  handleSave = () => {
    var warn = false;
    const values = Object.values(this.state);
    for(var i = 0; i < 25; i ++)
      if(values[i] === '') {
        warn = true;
        break;
      }
    if(warn)
      this.setState({
        Warning: true, warningMessage: 'Please fill-in all required fields'
      });
    else if(!this.state.Terms)
      this.setState({
        Warning: true, warningMessage: 'Please accept Terms & Conditions to continue'
      });
    else {
      this.setState({ disableSave: true });
      const keys = Object.keys(this.state);
      var data = {};
      for(i = 0; i < 24; i++)
        data[keys[i]] = values[i];
      addLMDRMA(data)
        .then((rma) => {
          if(rma['status'] === 'true') {
            this.setState({ Message: 'Thank you for submitting the RMA. It may take a while before this RMA will appear on the list of RMAs. Please check back after some time (It was send successfully, please do not resend)' });
            this.props.setLMDCache({});
          }
          else
            this.setState({ warningMessage: 'Submission failed. Please try back after some time' });
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

  render() {
    this.updateCache();
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>Laser Measurement RMA</font></center>
        </Typography>
        <p />
          <Paper style={{ padding: '10px' }}>
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Contact Name'
                name='ContactName'
                value={this.state.ContactName}
                error={this.state.Warning && this.state.ContactName === ''}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Contact E-Mail'
                name='ContactEMail'
                value={this.state.ContactEMail}
                error={this.state.Warning && this.state.ContactEMail === ''}
              />
            </Grid>
          </Grid>
          <Typography variant='caption'>
            <Link to='/profile?lmdrmaform'>Update Profile</Link>
          </Typography>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Company Name'
                name='CompanyName'
                value={this.state.CompanyName}
                error={this.state.Warning && this.state.CompanyName === ''}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='Billing E-Mail'
                name='BillingEMail'
                value={this.state.BillingEMail}
                error={this.state.Warning && this.state.BillingEMail === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <Typography variant="caption">
                Select an existing address from the list or click on the "update or add New Address" button if the address isn't on the list
              </Typography>
              <TextField
                fullWidth
                select
                label='Select an existing address from the list'
                name='Shipping'
                value={this.state.ShippingAddressID}
                onChange={(event) => this.handleAddressChange(event)}
              >
                {this.state.Addresses.map((option) => (
                  <MenuItem key={option.ADDRESSID} value={option.ADDRESSID}>
                    {option.ADDRESS1}, {option.CITY}, {option.STATE}, {option.POSTALCODE}, {option.COUNTRY}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                disabled
                required
                fullWidth
                label='Shipping Address'
                name='ShippingAddress'
                value={this.state.ShippingAddress}
                error={this.state.Warning && this.state.ShippingAddress === ''}
              />
              <TextField
                disabled
                required
                fullWidth
                label='City'
                name='ShippingCity'
                value={this.state.ShippingCity}
                error={this.state.Warning && this.state.ShippingCity === ''}
              />
              <Grid container>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='State'
                    name='ShippingState'
                    value={this.state.ShippingState}
                    error={this.state.Warning && this.state.ShippingState === ''}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: '5px' }}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='Zip'
                    name='ShippingZip'
                    value={this.state.ShippingZip}
                    error={this.state.Warning && this.state.ShippingZip === ''}
                  />
                </Grid>
              </Grid>
              <TextField
                disabled
                required
                fullWidth
                label='Country'
                name='ShippingCountry'
                value={this.state.ShippingCountry}
                error={this.state.Warning && this.state.ShippingCountry === ''}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                fullWidth
                select
                label='Select a billing address from the list'
                name='Billing'
                value={this.state.BillingAddressID}
                onChange={(event) => this.handleAddressChange(event)}
              >
                {this.state.Addresses.map((option) => (
                  <MenuItem key={option.ADDRESSID} value={option.ADDRESSID}>
                    {option.ADDRESS1}, {option.CITY}, {option.STATE}, {option.POSTALCODE}, {option.COUNTRY}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                disabled
                required
                fullWidth
                label='Billing Address'
                name='BillingAddress'
                value={this.state.BillingAddress}
                error={this.state.Warning && this.state.BillingAddress === ''}
              />
              <TextField
                disabled
                required
                fullWidth
                label='City'
                name='BillingCity'
                value={this.state.BillingCity}
                error={this.state.Warning && this.state.BillingCity === ''}
              />
              <Grid container>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='State'
                    name='BillingState'
                    value={this.state.BillingState}
                    error={this.state.Warning && this.state.BillingState === ''}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: '5px' }}>
                  <TextField
                    disabled
                    required
                    fullWidth
                    label='Zip'
                    name='BillingZip'
                    value={this.state.BillingZip}
                    error={this.state.Warning && this.state.BillingZip === ''}
                  />
                </Grid>
              </Grid>
              <TextField
                disabled
                required
                fullWidth
                label='Country'
                name='BillingCountry'
                value={this.state.BillingCountry}
                error={this.state.Warning && this.state.BillingCountry === ''}
              />
            </Grid>
          </Grid>
          <Typography variant='caption'>
            <Link to='/accountdetailsteam?lmdrmaform'>Update Address</Link>
          </Typography>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '5px' }}>
              <TextField
                fullWidth
                select
                label='Please select a product from the list here or enter below'
                value=''
                onChange={(event) => this.handleProductChange(event)}
              >
                {this.state.Products.map((option) => (
                  <MenuItem key={option.Serial} value={option.Serial}>
                    {option.Product}, {option.Serial}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <p />
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                select
                label='Product'
                name='Product'
                value={this.state.Product}
                error={this.state.Warning && this.state.Product === ''}
                onChange={(event) => this.handleUserInput(event)}
              >
                {Product.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='Serial Number'
                name='SerialNumber'
                value={this.state.SerialNumber}
                error={this.state.Warning && this.state.SerialNumber === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='RMA Description'
                name='RMADescription'
                value={this.state.RMADescription}
                error={this.state.Warning && this.state.RMADescription === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                select
                label='Warranty'
                name='Warranty'
                value={this.state.Warranty}
                error={this.state.Warning && this.state.Warranty === ''}
                onChange={(event) => this.handleUserInput(event)}
              >
                {Warranty.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                select
                label='Service Center'
                name='ServiceCenter'
                value={this.state.ServiceCenter}
                error={this.state.Warning && this.state.ServiceCenter === ''}
                onChange={(event) => this.handleUserInput(event)}
              >
                {ServiceCenter.map((option) => (
                  <MenuItem key={option.key} value={option.key}>
                    {option.val}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                select
                label='Currency'
                name='Currency'
                value={this.state.Currency}
                error={this.state.Warning && this.state.Currency === ''}
                onChange={(event) => this.handleUserInput(event)}
              >
                {this.currencyItmes()}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                label='Year Purchased'
                name='PurchaseYear'
                value={this.state.PurchaseYear}
                error={this.state.Warning && this.state.PurchaseYear === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} style={{ padding: '5px' }}>
              <TextField
                disabled
                required
                fullWidth
                label='Freight Insurance'
                name='FreightInsurance'
                value={this.state.FreightInsurance}
                error={this.state.Warning && this.state.FreightInsurance === ''}
                InputProps={{
                  startAdornment: <InputAdornment position='start'>
                    {typeof Currency[this.state.Currency] === 'undefined' ? '' : Currency[this.state.Currency]}
                  </InputAdornment>,
                  endAdornment: <InputAdornment position='end'>
                    {this.state.Currency}
                  </InputAdornment>
                }}
              />
            </Grid>
          </Grid>
          <p />
          <Grid container style={{ border: '1px solid silver' }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '5px' }}><br />
              <TextField
                fullWidth
                select
                label='Select Fault Description from the list here or type in below'
                name='FaultDescription'
                value=''
                onChange={(event) => this.handleFaultChange(event)}
              >
                <MenuItem value='Annual Calibration'>Annual Calibration</MenuItem>
                <MenuItem value='Ranging Issue'>Ranging Issue</MenuItem>
                <MenuItem value='Incorrect Angle'>Incorrect Angle</MenuItem>
                <MenuItem value='No Power'>No Power</MenuItem>
                <MenuItem value='Mechanical issue'>Mechanical issue</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '5px' }}>
              <TextField
                required
                fullWidth
                multiline={true}
                rows={2}
                name='FaultDescription'
                value={this.state.FaultDescription}
                error={this.state.Warning && this.state.FaultDescription === ''}
                onChange={(event) => this.handleUserInput(event)}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                variant='raised'
                color='primary'
                fullWidth
                style={{ textTransform: 'none' }}
                onClick={this.handleSave}
                disabled={this.state.disableSave}
              >
                Create new RMA &nbsp; <Create />
              </Button>
            </Grid>
          </Grid>
          <Typography variant='caption'>
            <Checkbox
              name='terms'
              color='primary'
              checked={this.state.Terms}
              onClick={() => this.setState({ Terms: !this.state.Terms }) }
            />
            Terms & Conditions - Service Centre: &nbsp;
            <Link to='/LMD_SERVICE_CONDITIONS_CARLSON_LMD_CANADA.pdf' target='_blank'>Canada</Link> &nbsp;
            <Link to='/LMD_SERVICE_CONDITIONS_CARLSON_LMD_AUSTRALIA.pdf' target='_blank'>Australia</Link> &nbsp;
            <Link to='/LMD_SERVICE_CONDITIONS_CARLSON_LMD_UK.pdf' target='_blank'>United kingdom</Link>
          </Typography>
        </Paper>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.Message !== '' || this.state.warningMessage !== ''}
          onClose={() => this.setState({ Message: '', warningMessage: '' })}
          message={
            <span>
              <div style={{ textAlign: 'left', whiteSpace: 'pre-line' }}>
                {this.state.Message}
              </div>
              <span style={{ color: 'red' }}>
                {this.state.warningMessage}
              </span>
            </span>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {LMDCache: state.LMDCache};
}
const mapDispatchToProps = (dispatch) => ({
  setLMDCache: (cache) => dispatch(LMDCache(cache))
});
const LMDRMAForm = connect(mapStateToProps, mapDispatchToProps)(App);

export default LMDRMAForm;



// WEBPACK FOOTER //
// ./src/components/home/LMDRMAForm.js